window.Vue = require('vue');
Vue.component('form-brochure', require('./forms/form-brochure.vue').default);
Vue.component('form-contact', require('./forms/form-contact.vue').default);
Vue.component('form-newsletter', require('./forms/form-newsletter.vue').default);
Vue.component('form-search', require('./forms/form-search.vue').default);

const app = new Vue({
    el: '#website',
    data: {
        hamburgerIsActive: false
    },

    methods: {
        toggleHamburger() {
            this.hamburgerIsActive = !this.hamburgerIsActive;

            if (this.hamburgerIsActive) {
                document.querySelector('#website > nav').classList.add('--menu');
            } else {
                document.querySelector('#website > nav').classList.remove('--menu');
            }
        }
    }
});

import {
    CLASS_ANIMATED_IN,
    CLASS_ANIMATING_IN,
    Controller,
    ID_WEBSITE
} from "./src/Controller";
import {CountUp} from "countup.js";
import QuoteSlider from "./objects/quote-slider";

$(() => {
    const quoteSliders = document.querySelectorAll('.quote-slider');

    if (quoteSliders.length > 0) {
        quoteSliders.forEach((quoteSlider) => {
            const object = new QuoteSlider(quoteSlider);
            object.init();
        });
    }
});


/**
 * De controller van de website.
 *
 * @type {Controller}
 */
const controller = new Controller(
    document.getElementById(ID_WEBSITE)
);

/**
 * @param {HTMLElement[]} elements
 */
function controlVisibleElements(elements) {
    if (elements.length <= 0) {
        return false;
    }

    elements.forEach((element) => {
        if (element.classList.contains(CLASS_ANIMATED_IN)
            || element.classList.contains(CLASS_ANIMATING_IN)
        ) {
            return false;
        }

        if (element.classList.contains('section--color-transition')) {
            controller.animateIn(element, 2000);

            setTimeout(() => {
                const statistics = element.querySelectorAll('.statistic');

                statistics.forEach((statistic) => {
                    const options = {
                        separator: '.',
                        decimal: ',',
                        prefix: statistic.getAttribute('data-prefix'),
                        suffix: statistic.getAttribute('data-suffix'),
                        duration: 4
                    };

                    let countup = new CountUp(statistic, parseInt(statistic.getAttribute('data-number')), options);
                    if (!countup.error) {
                        countup.start();
                    } else {
                        console.log(countup.error);
                    }
                })
            }, 650)
        } else if (element.querySelector('.grid') !== null) {
            let time = 1000;
            const panels = element.querySelectorAll('.grid__item');

            time = time + (650 + (200 * panels.length));

            controller.animateIn(element, time);
        } else {
            controller.animateIn(element, 1250);
        }
    });
}

window.addEventListener('load', () => {
    controller.setLoadedState();

    controller.addViewportElement(
        document.querySelector('.logo-container')
    );
    controller.addViewportElement(
        document.querySelector('nav')
    );
    controller.addViewportElement(
        document.querySelector('header')
    );

    const main = document.querySelector('main');
    const rows = main.querySelectorAll('section');
    const headerHeight = document.querySelector('header .intro');
    const minScrollHeight = headerHeight.offsetHeight - 79;

    rows.forEach((row) => {
        controller.addViewportElement(row);
    });

    controller.conversion = document.querySelector('.conversion');
    controller.footer = document.querySelector('#website > footer');

    controlVisibleElements(
        controller.getVisibleViewportElements()
    );

    if (window.top.scrollY > minScrollHeight) {
        document.querySelector('nav').classList.add("scrolled");
    } else {
        document.querySelector('nav').classList.remove("scrolled");
    }

    window.addEventListener('scroll', () => {
        controlVisibleElements(
            controller.getVisibleViewportElements()
        );

        if (window.top.scrollY > minScrollHeight) {
            document.querySelector('nav').classList.add("scrolled");
        } else {
            document.querySelector('nav').classList.remove("scrolled");
        }

        if (controller.isAtFooter()) {
            controller.hideConversion();
        } else {
            controller.showConversion();
        }
    });
});

const scrollButton = document.querySelector('.scroll-button');

if (scrollButton) {
    scrollButton.addEventListener('click', () => {
        const position = $(scrollButton).position().top;
        $('html,body').animate({
            scrollTop: position
        }, 'slow');
        return false;
    });
}
